export const buildPumpRowInitialValues = (fields = []) => Object.fromEntries(fields.map(field => [field.id, {
  fieldValueId: field.selectedValueId,
  inputValue: String(field.fieldName || '').trim().toLowerCase() === 'quantity'
    ? '1'
    : field.performance?.inputValue ?? field.inputValue,
}]));
